export default __webpack_public_path__ + "static/footer-bg-2697970f211a0ebb7278828e477138ad.png";